import React from "react";

const ContactUs = () => {
  return (
    <button
      className="border border-primeColor text-primeColor hover:border-darkPink hover:text-darkPink font-semibold bg-white opacity-90 hover:opacity-100
   border-lightTextDesignColor font-titleFont text-darkBgColor hover:text-lightTextDesignColor 
text-xl w-56 py-3 text-center transition-hover duration-500 rounded-md cursor-pointer flex flex-row justify-center items-center group"
    >
      Contact Us
      <span
        className="after:bg-primeColor group-hover:after:bg-darkPink bg-gradient-to-r from-lightTextDesignColor via-blue-600 group-hover:after:bg-lightTextDesignColor from-lightTextDesignColor
 w-20 h-[1px] flex after:-mt-[5px] group-hover:after:translate-x-[70px] bg-primeColor group-hover:bg-darkPink ml-3 mt-1 after:w-3 after:h-3 after:rounded-full after:transition-transform after:duration-[.7s]"
      ></span>
    </button>
  );
};

export default ContactUs;
